<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    class="home-icon"
  >
    <!-- Casa base -->
    <path d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
    <!-- Puerta -->
    <polyline points="9,22 9,12 15,12 15,22"/>
    <!-- Ventana izquierda -->
    <rect x="6" y="14" width="2" height="2" fill="currentColor" opacity="0.6"/>
    <!-- Ventana derecha -->
    <rect x="16" y="14" width="2" height="2" fill="currentColor" opacity="0.6"/>
  </svg>
</template>

<script>
export default {
  name: "HomeIcon",
};
</script>

<style scoped>
.home-icon {
  height: 100%;
  width: 100%;
}
</style>